export default "__VITE_ASSET__xbYxdRkR__"